<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="类别"
      edit-title
      id-key="EmpTypeId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="类别名称" prop="TypeName">
          <el-input v-model="data.TypeName" placeholder="请输入类别名称" />
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input type="number" v-int v-model="data.Sn" style="width: 100px"></el-input>
          <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status" >
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        EmpTypeId: 0,
        TypeName: "",        
        Status: 1,
        Sn:null,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ent/emptype").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        TypeName: [{ required: true, message: "请输入岗位名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split("/").join(""): location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    onCreateOpened(data) {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {},

    onClosed() {
      this.showList = [];
    },
  },
};
</script>